module.exports = __webpack_public_path__ + "static/auth0-image-alignment-cdfe9106bc160d1e6065384fb58a6e6e.png";